import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useCargoFuncao = () => {
  const [cargoFuncao, setCargoFuncao] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchCargoFuncao = async () => {
      try {
        const response = await httpClient.get(
          `/api/fornecedorrepresentante/cargofuncao`,
        );

        const options = response.data.map(
          (cargoFuncao: { value: number; label: string }) => ({
            value: cargoFuncao.value.toString(),
            label: cargoFuncao.label,
          }),
        );
        setCargoFuncao(options);
      } catch (error) {
        console.error('Erro ao buscar Cargo Função', error);
      }
    };

    fetchCargoFuncao();
  }, []);

  return cargoFuncao;
};
